<!-- @format -->

<template>
	<disabled-text
		v-if="disabled && pcProps.showDisabledText"
		v-bind="disabledValue"
		:show-tag="true"
		@on-click="onClick"
	/>
	<pc-upload
		v-model="value"
		:show-table="pcProps.hasOwnProperty('showTable') ? pcProps.showTable : true"
		:limit="pcProps.replaceFile ? 1 : pcProps.maxUpLength"
		:file-size="pcProps.maxSize"
		:file-type="fileType"
		:is-show-tip="pcProps.showTip"
		style="width: 100%"
		:accept="pcProps.accept"
		:disabled="disabled"
		:replace-file="pcProps.replaceFile"
		:on-download-template="pcProps.templateFile ? handleDownload : undefined"
		:show-ower-list="true"
	/>
</template>

<script setup lang="ts">
	import { downloadByUrl, getFileUrlById } from '@power/runtime-vue3';
	import { type WidgetConfigType } from '../../types';
	import DisabledText from './disabledText.vue';
	import { PcUpload } from '@/components';
	import { resource } from '@/api/global/index';
	interface Props {
		modelValue: string;
		pcProps: WidgetConfigType;
		disabled?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const fileType = computed(() => (props.pcProps.accept ? props.pcProps.accept.split(',') : []));

	const isV1Ver = 'V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION;

	const uploadRef = ref<InstanceType<typeof PcUpload>>();

	const value = computed({
		get() {
			return Array.isArray(props.modelValue) ? props.modelValue : props.modelValue ? props.modelValue?.split(',') : [];
		},
		set(value) {
			emit('update:modelValue', value.join(','));
		},
	});

	const disabledValue = computed(() => {
		const fieldList: any = uploadRef.value?.fileList || [];
		return {
			value: fieldList.map((i) => i.id),
			params: fieldList.map((i) => ({
				label: i.name,
				value: i.id,
				url: i.url,
			})),
		};
	});

	const handleDownload = async () => {
		const id = props.pcProps.templateFile;
		const res = await resource(id);
		const url = getFileUrlById(id);
		downloadByUrl({ url: `${window.location.origin}${url}`, fileName: res.data.resourceName });
	};

	const onClick = (row) => {
		let url = '';
		if (isV1Ver) {
			url = row.url;
		} else {
			url = `${window.location.origin}${row.url}`;
		}
		downloadByUrl({ url, fileName: row.label });
	};
</script>

<style scoped></style>
